import { BeforeResetEvent, MapClickEvent, MarkerActivateEvent, MarkerClickEvent, MarkerCreatedEvent, PanEndEvent, PanEvent, ResetEvent, ShapeClickEvent, ShapeCreatedEvent, ShapeFeatureCreatedEvent, ShapeMouseEnterEvent, ShapeMouseLeaveEvent, ZoomEndEvent, ZoomStartEvent } from '../common/events';
var EVENT_MAP = {
    beforeReset: BeforeResetEvent,
    mapClick: MapClickEvent,
    markerActivate: MarkerActivateEvent,
    markerClick: MarkerClickEvent,
    markerCreated: MarkerCreatedEvent,
    panEnd: PanEndEvent,
    pan: PanEvent,
    reset: ResetEvent,
    shapeClick: ShapeClickEvent,
    shapeCreated: ShapeCreatedEvent,
    shapeFeatureCreated: ShapeFeatureCreatedEvent,
    shapeMouseEnter: ShapeMouseEnterEvent,
    shapeMouseLeave: ShapeMouseLeaveEvent,
    zoomEnd: ZoomEndEvent,
    zoomStart: ZoomStartEvent
};
/**
 * @hidden
 */
function create(name, args, sender) {
    if (EVENT_MAP[name]) {
        return new EVENT_MAP[name](args, sender);
    }
}
export { create };
